/**
 * レンタルカタログ ライトボックス。
 *
 * `.rental-catalog__link` のクリックで、カタログを拡大表示する。
 * - data-zoom-type="image": 1ページ目のクリーン画像をモーダルで拡大（ブラウザのPDFポリシーに依存しない）。
 * - data-zoom-type="pdf"  : 画像が無いケースのフォールバック。元PDFを別タブで開く。
 * モーダルはオーバーレイ／閉じるボタン／ESC で閉じる。JS無効時はリンクの href（別タブ）にフォールバックする。
 */
(function () {
  'use strict';

  function isSafeUrl(url) {
    return /^https?:\/\//i.test(url) || url.charAt(0) === '/';
  }

  function init() {
    var links = document.querySelectorAll('.rental-catalog__link[data-zoom]');
    if (!links.length) {
      return;
    }

    var modal = null;
    var imgEl = null;
    var openLink = null;
    var lastFocus = null;

    function build() {
      modal = document.createElement('div');
      modal.className = 'rental-lightbox';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'カタログ');
      modal.hidden = true;
      modal.innerHTML =
        '<div class="rental-lightbox__overlay" data-close></div>' +
        '<div class="rental-lightbox__dialog" role="document">' +
        '<button type="button" class="rental-lightbox__close" data-close aria-label="閉じる">&times;</button>' +
        '<img class="rental-lightbox__img" alt="" />' +
        '<a class="rental-lightbox__open" target="_blank" rel="noopener">PDFをダウンロード / 別タブで開く</a>' +
        '</div>';
      document.body.appendChild(modal);
      imgEl = modal.querySelector('.rental-lightbox__img');
      openLink = modal.querySelector('.rental-lightbox__open');
      modal.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-close')) {
          close();
        }
      });
    }

    function open(imageUrl, downloadUrl, title) {
      if (!modal) {
        build();
      }
      lastFocus = document.activeElement;
      imgEl.src = imageUrl;
      imgEl.alt = title || '';
      if (openLink) {
        openLink.href = downloadUrl || imageUrl;
      }
      modal.hidden = false;
      document.documentElement.classList.add('rental-lightbox-open');
      var closeBtn = modal.querySelector('.rental-lightbox__close');
      if (closeBtn) {
        closeBtn.focus();
      }
      document.addEventListener('keydown', onKey);
    }

    function close() {
      if (!modal || modal.hidden) {
        return;
      }
      modal.hidden = true;
      imgEl.removeAttribute('src');
      document.documentElement.classList.remove('rental-lightbox-open');
      document.removeEventListener('keydown', onKey);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        close();
      }
    }

    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('click', function (e) {
        var zoomUrl = link.getAttribute('data-zoom');
        var type = link.getAttribute('data-zoom-type');
        var downloadUrl = link.getAttribute('data-download') || link.href;
        if (!zoomUrl || !isSafeUrl(zoomUrl)) {
          return; // 不正URLは既定動作（別タブ）に委ねる。
        }
        if (type === 'image') {
          e.preventDefault();
          open(zoomUrl, downloadUrl, link.getAttribute('data-title') || '');
        }
        // type === 'pdf' のときは preventDefault しない＝href(別タブ)で開く。
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
